export default "__VITE_ASSET__DNREP$TC__"